export default __webpack_public_path__ + "static/media/logo.ecca63b1.svg";